import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import Button from 'components/CustomButtons/Button.js';
import NewVOModal from 'components/NewVOModal';
import styles from 'assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js';
import rocketFastTrack from 'assets/img/big-rocket.svg';
import FastTrackModal from 'components/FastTrackModal';
import { useSelector } from 'react-redux';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import FastTrackInfoModal from 'components/FastTrackInfoModal';
import { theme } from '../../theme';
import { CreateNewOpportunityButton } from 'modules/vendorOpportunity';
import { Typography, Stack, AppBar, Toolbar } from '@mui/material';
import { expandedSidebarWidth, collapsedSidebarWidth } from 'constants/common';

const useStyles = makeStyles(styles);

export default function AdminNavbar(props) {
  const classes = useStyles();
  const history = useHistory();
  const { isDrawerOpen, brandText, fastTrackOption } = props;
  const [enableFastTrack, setEnableFastTrack] = useState(false);
  const [isNewVOModalOpen, setIsNewVOModalOpen] = useState(false);
  const [fastTrackStatus, setFastTrackStatus] = useState('');
  const [fastTrackInfo, setFastTrackInfo] = useState(false);
  const [fastTrackModal, setFastTrackModal] = useState(false);
  const [voReady, setVoReady] = useState(false);

  const currentVo = useSelector(state => state.vo);
  const vp = useSelector(state => state.vp);

  const [isFastTrackEnabled, setIsFastTrackEnabled] = useState(false);

  const creditApp = useSelector(state => state.creditApp);

  useEffect(() => {
    if (window && !voReady)
      window.addEventListener('voUpdated', e => {
        setVoReady(e.detail.updated);
      });
  }, []);

  useEffect(() => {
    if (currentVo) {
      let fastTrackStatus = _.get(currentVo, 'fastTrackStatus', null);
      setFastTrackStatus(fastTrackStatus);
      setEnableFastTrack(currentVo.entityType !== 'CASH_SALE');
      setIsFastTrackEnabled(
        ['YES_SET_CAMUNDA_PROCESS_CODE', 'YES_AUTOMATED_FOR_DEALER', 'YES_BUT_DEALER_MUST_TRIGGER'].includes(
          vp?.fastTrackSetting
        )
      );
    }
  }, [currentVo]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const fastTrackModalOpen = queryParams.get('fastTrackModal');

    if (voReady && fastTrackModalOpen === 'true' && !_.isEmpty(creditApp) && !_.isEmpty(currentVo)) {
      setTimeout(() => {
        if (queryParams.has('fastTrackModal')) {
          queryParams.delete('fastTrackModal');
          history.replace({
            search: queryParams.toString(),
          });
        }

        handleOpenFastTrackModal();
      }, 1500);
    }
  }, [creditApp, currentVo, voReady]);

  const handleOpenFastTrackModal = e => {
    if (e) e.preventDefault();

    setFastTrackModal(true);
  };

  const renderFastTrackStatus = fastTrackStatus => {
    switch (fastTrackStatus) {
      case 'AWAITING_LENDER_APPROVAL':
        return (
          <>
            <div className={classes.fastTrackTextColor}>This opportunity has been</div>
            <div className={classes.fastTrackTextStyles}>fast tracked</div>
          </>
        );
      case 'AWAITING_DEALER_APPROVAL':
        return (
          <>
            <div className={classes.fastTrackTextStyles} style={{ color: '#fff' }}>
              Send Proposal
            </div>
            <div className={classes.fastTrackTextColor} style={{ color: '#fff' }}>
              to the customer
            </div>
          </>
        );
      case 'REQUIRES_DEALER_ATTENTION':
        return (
          <>
            <div className={classes.fastTrackTextColor}>This opportunity</div>
            <div className={classes.fastTrackTextStyles} style={{ color: 'orange' }}>
              Requires Attention
            </div>
          </>
        );
      case 'PROPOSAL_SENT':
        return (
          <>
            <div className={classes.fastTrackTextColor}>Proposal</div>
            <div className={classes.fastTrackTextStyles}>Sent</div>
            <div className={classes.fastTrackTextColor}>to customer</div>
          </>
        );
      case 'PROPOSAL_VIEWED':
        return (
          <>
            <div className={classes.fastTrackTextColor}>Proposal</div>
            <div className={classes.fastTrackTextStyles}>Viewed</div>
            <div className={classes.fastTrackTextColor}>by customer</div>
          </>
        );
      case 'PROPOSAL_ACCEPTED':
        return (
          <>
            <div className={classes.fastTrackTextColor}>Proposal</div>
            <div className={classes.fastTrackTextStyles} style={{ color: '#54a954' }}>
              Accepted
            </div>
            <div className={classes.fastTrackTextColor}>by customer</div>
          </>
        );
      case 'LENDER_DECLINED':
        return (
          <>
            <div className={classes.fastTrackTextStyles} style={{ color: 'red' }}>
              Declined
            </div>
            <div className={classes.fastTrackTextColor}>by lender</div>
          </>
        );
      case 'PRESCREEN_FAILED':
        return (
          <>
            <div className={classes.fastTrackTextStyles} style={{ color: 'red' }}>
              Failed Prescreen
            </div>
            <div className={classes.fastTrackTextColor}>- please see notes</div>
          </>
        );
      case 'CANCELED':
        return (
          <>
            <div className={classes.fastTrackTextColor}>This opportunity has been</div>
            <div className={classes.fastTrackTextStyles} style={{ color: 'red' }}>
              Canceled
            </div>
          </>
        );
      default:
        return (
          <>
            <div className={classes.fastTrackTextStyles} style={{ color: '#fff' }}>
              fast track
            </div>
            <div className={classes.fastTrackTextColor} style={{ color: '#fff' }}>
              this opportunity
            </div>
          </>
        );
    }
  };

  const renderFastTrackNavbar = (isDesktop = false, fastTrackStatus, voReady) =>
    voReady &&
    fastTrackOption &&
    isFastTrackEnabled &&
    enableFastTrack &&
    !_.isEmpty(currentVo) && (
      <>
        <div>
          <Button
            style={{
              margin: 0,
              padding: '6px 8px',
              fontSize: '0.875rem',
              background:
                fastTrackStatus === 'AWAITING_DEALER_APPROVAL'
                  ? 'rgb(131, 75, 255)'
                  : fastTrackStatus === null
                    ? `linear-gradient( 95deg,${theme.palette.primary.main} 0%,${theme.palette.primary.main} 50%,${theme.palette.primary.main} 100%)`
                    : 'none',
              boxShadow: fastTrackStatus !== 'AWAITING_DEALER_APPROVAL' || !!fastTrackStatus ? 'none' : undefined,
            }}
            onClick={e => {
              if (fastTrackStatus !== 'PRESCREEN_FAILED') handleOpenFastTrackModal(e);
            }}
          >
            <div style={{ display: 'flex', columnGap: 5, alignItems: 'center', margin: 0, padding: 0 }}>
              <img src={rocketFastTrack} alt="fast track icon" className={classes.fastTrackImageStyles} />
              {renderFastTrackStatus(fastTrackStatus)}
            </div>
          </Button>
          <InfoIcon
            style={{ fontSize: 20, color: theme.palette.primary.main, cursor: 'pointer' }}
            onClick={() => setFastTrackInfo(true)}
          />
        </div>
      </>
    );

  return (
    <>
      <AppBar
        className={classes.appBar}
        sx={{ padding: `0 0.5rem 0 calc(${isDrawerOpen ? expandedSidebarWidth : collapsedSidebarWidth}px + 8px)` }}
      >
        <Toolbar style={{ justifyContent: 'space-between', padding: 0 }}>
          <Stack direction="row" alignItems="center">
            <Stack direction="row" gap="1rem">
              <Typography id="pageLayoutTitle" variant="h5" sx={{ marginLeft: '1rem' }}>
                {brandText}
              </Typography>

              {renderFastTrackNavbar(true, fastTrackStatus, voReady)}
            </Stack>
          </Stack>

          <CreateNewOpportunityButton handleClick={() => setIsNewVOModalOpen(true)} />
        </Toolbar>
      </AppBar>

      {vp && currentVo && creditApp && (
        <FastTrackModal
          open={fastTrackModal}
          onClose={() => setFastTrackModal(false)}
          currentVo={currentVo}
          creditApp={creditApp}
          globalVp={vp}
        />
      )}

      <FastTrackInfoModal open={fastTrackInfo} onClose={() => setFastTrackInfo(false)} showButton={false} />

      <NewVOModal open={isNewVOModalOpen} onClose={() => setIsNewVOModalOpen(false)} />
    </>
  );
}

AdminNavbar.propTypes = {
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  isDrawerOpen: PropTypes.bool,
  brandText: PropTypes.string,
  fastTrackOption: PropTypes.any,
};
